// Quill.js configuration to match TinyMCE functionality
const TOOLBAR_CONFIG = [
  [{ header: [1, 2, 3, 4, 5, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [
    {
      more: [
        'link',
        'image',
        'blockquote',
        'code-block',
        'subscript',
        'superscript',
        'clean'
      ]
    }
  ]
];

const FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'align',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'blockquote',
  'code-block',
  'script',
  'more'
];

const MODULES = {
  toolbar: {
    container: TOOLBAR_CONFIG,
    handlers: {
      format: function(value) {
        if (value === 'Bold') {
          this.quill.format('bold', !this.quill.getFormat().bold);
        } else if (value === 'Italic') {
          this.quill.format('italic', !this.quill.getFormat().italic);
        } else if (value === 'Underline') {
          this.quill.format('underline', !this.quill.getFormat().underline);
        } else if (value === 'Strike') {
          this.quill.format('strike', !this.quill.getFormat().strike);
        } else if (value === 'Decrease Indent') {
          this.quill.format('indent', '-1');
        } else if (value === 'Increase Indent') {
          this.quill.format('indent', '+1');
        }
      },
      lists: function(value) {
        if (value === 'Ordered List') {
          this.quill.format('list', 'ordered');
        } else if (value === 'Bullet List') {
          this.quill.format('list', 'bullet');
        }
      },
      scripts: function(value) {
        if (value === 'Subscript') {
          this.quill.format('script', 'sub');
        } else if (value === 'Superscript') {
          this.quill.format('script', 'super');
        }
      },
      more: function(value) {
        switch (value) {
          case 'link':
            const url = prompt('Enter the link URL:');
            if (url) {
              this.quill.format('link', url);
            }
            break;
          case 'image':
            const imageUrl = prompt('Enter the image URL:');
            if (imageUrl) {
              const range = this.quill.getSelection();
              this.quill.insertEmbed(range.index, 'image', imageUrl, 'user');
            }
            break;
          case 'blockquote':
            this.quill.format('blockquote', !this.quill.getFormat().blockquote);
            break;
          case 'code-block':
            this.quill.format(
              'code-block',
              !this.quill.getFormat()['code-block']
            );
            break;
          case 'subscript':
            this.quill.format('script', 'sub');
            break;
          case 'superscript':
            this.quill.format('script', 'super');
            break;
          case 'clean':
            this.quill.removeFormat(this.quill.getSelection());
            break;
          default:
            break;
        }
      }
    }
  },
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false
  },
  history: {
    delay: 2000,
    maxStack: 500,
    userOnly: true
  }
};

const THEME = 'snow'; // 'snow' or 'bubble'

export { TOOLBAR_CONFIG, FORMATS, MODULES, THEME };
